/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-square-x': {
    width: 43.412,
    height: 43.411,
    viewBox: '0 0 43.412 43.411',
    data:
      '<g data-name="Group 1553"><path pid="0" data-name="Path 411" d="M5.867 0h31.678a5.867 5.867 0 0 1 5.867 5.866v31.679a5.867 5.867 0 0 1-5.867 5.866H5.867A5.865 5.865 0 0 1 0 37.545V5.864A5.866 5.866 0 0 1 5.867-.002"/><path pid="1" data-name="Path 412" d="M32.386 32.155l-8.307-12.062-.939-1.364-5.939-8.628-.493-.714h-7.3l1.78 2.581 7.9 11.474.939 1.362 6.345 9.218.493.715h7.3zm-4.651.939l-6.591-9.578-.939-1.363-7.649-11.113h3.284l6.186 8.988.938 1.363 8.056 11.7z" _fill="#fff"/><path pid="2" data-name="Path 413" d="M20.206 22.153l.939 1.363-1.113 1.29-8.538 9.933H9.388l9.7-11.3z" _fill="#fff"/><path pid="3" data-name="Path 414" d="M33.285 9.386l-9.2 10.708-1.112 1.29-.939-1.363 1.113-1.29 6.235-7.257 1.8-2.088z" _fill="#fff"/></g>'
  }
})
